import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-flat',
    templateUrl: './flat.component.html',
    styleUrls: ['./flat.component.scss'],
    standalone: false
})
export class FlatComponent {
  @Input() public flatId: any = null;
  @Input() public current_path: any = 'common';

  constructor() {
  }
}
